/* global angular, $ */
angular.module('ua5App')
    .directive('selectAutowidth', [function() {
        return {
            restrict: 'A',
            link: function($scope, element, attrs) {
                var EXTRA_WIDTH = 20;
                var $$element;
                $$element = $(element);
                function setWidth() {
                    var $$span;
                    var w;
                    // Throw a hidden span on the page with the selected
                    // option's text and then measure its width
                    $$span = $('<span>');
                    $$span.css({
                        position: 'absolute',
                        visibility: 'hidden'
                    });
                    $$span.text($$element.find(':selected').text());
                    $('body').append($$span);
                    w = $$span.width();
                    // Assign calculated with plus some extra padding to
                    // account for the down arrow to the select tag
                    $$element.width(w + EXTRA_WIDTH);
                    $$span.remove();
                }
                // Initialize the select menu with the width of the selected
                // option
                setWidth();
                // Reset width when the window resizes incase font-sizes have
                // caused a change in width
                $scope.$on('app:resized', setWidth);
                // Change select width when a new option is selected
                $$element.on('change.selectAutowidth', setWidth);
                // Cleanup any listeners
                $scope.$on('$destroy', function() {
                    $$element.off('.selectAutowidth');
                });
            }
        };
    }])
;
